var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.454 2.6792C19.3504 2.14329 20.0212 1.29944 20.341 0.3052C19.4986 0.805002 18.577 1.15708 17.616 1.3462C16.2836 -0.063273 14.1725 -0.406274 12.4624 0.508856C10.7523 1.42399 9.8665 3.37069 10.3 5.2612C6.84961 5.08797 3.63497 3.45812 1.456 0.7772C0.31884 2.73862 0.899953 5.24598 2.784 6.5072C2.10271 6.4853 1.43653 6.30084 0.841 5.9692C0.841 5.9872 0.841 6.0052 0.841 6.0232C0.841394 8.06635 2.28137 9.82628 4.284 10.2312C3.65206 10.4031 2.98921 10.4284 2.346 10.3052C2.9092 12.0525 4.51955 13.2495 6.355 13.2852C4.83483 14.4783 2.95748 15.1254 1.025 15.1222C0.682471 15.1227 0.34021 15.103 0 15.0632C1.96239 16.3242 4.24637 16.9936 6.579 16.9912C9.82425 17.0135 12.943 15.7341 15.2377 13.4392C17.5324 11.1443 18.8116 8.02545 18.789 4.7802C18.789 4.5942 18.7847 4.4092 18.776 4.2252C19.6165 3.6178 20.3418 2.86535 20.918 2.0032C20.135 2.35026 19.3045 2.57812 18.454 2.6792Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f68389ba789461d82407d7208543f61f.svg";
export { ForwardRef as ReactComponent };